import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Pets from "./scenes/pets";
import VolunteerManagement from "./scenes/volunteermanagement";
import Vehicles from "./scenes/vehicles";
import Adoptions from "./scenes/adoptions";
import Vets from "./scenes/vets";
import Donations from "./scenes/donations";
import DispatchManagement from "./scenes/dispatchmanagement";
import FundraisingManagement from "./scenes/fundraisingmanagement";
import TrainingSupport from "./scenes/trainingsupport";
import TrainingSupportByTrainerGender from "./scenes/trainingsupport/indexByTrainerGender";
import TrainingSupportByTrainingType from "./scenes/trainingsupport/indexByTrainingType";
import TrainingSupportBySessionStatus from "./scenes/trainingsupport/indexBySessionStatus";
import AdoptionFollowUp from "./scenes/adoptionfollowup";
import AdoptionFollowUpByFollowUpStatus from "./scenes/adoptionfollowup/indexByFollowUpStatus";
import AdoptionFollowUpByContactMethod from "./scenes/adoptionfollowup/indexByContactMethod";
import LicensingManagement from "./scenes/licensingmanagement";
import LicensingManagementByStatus from "./scenes/licensingmanagement/indexByStatus";
import LicensingManagementByLicenseType from "./scenes/licensingmanagement/indexByLicenseType";
import LostAndFound from "./scenes/lostandfound";
import LostAndFoundByStatus from "./scenes/lostandfound/indexByStatus";
import LostAndFoundByReporterGender from "./scenes/lostandfound/indexByReporterGender";
import MedicalRecords from "./scenes/medicalrecords";
import BehavioralTracking from "./scenes/behavioraltracking";
import BehavioralTrackingByBehaviorType from "./scenes/behavioraltracking/indexByBehaviorType";
import Accounts from "./scenes/accounts";
import AccountsByAccountStatus from "./scenes/accounts/indexByAccountStatus";
import AccountsByAccountType from "./scenes/accounts/indexByAccountType";
import Inventory from "./scenes/inventory";
import InventoryByStatus from "./scenes/inventory/indexByStatus";
import InventoryByCategory from "./scenes/inventory/indexByCategory";
import InventoryByItemType from "./scenes/inventory/indexByItemType";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/pets" element={<ProtectedRoute element={<Pets searchTerm={searchTerm} />} />} />
<Route path="/volunteermanagement" element={<ProtectedRoute element={<VolunteerManagement searchTerm={searchTerm} />} />} />
<Route path="/vehicles" element={<ProtectedRoute element={<Vehicles searchTerm={searchTerm} />} />} />
<Route path="/adoptions" element={<ProtectedRoute element={<Adoptions searchTerm={searchTerm} />} />} />
<Route path="/vets" element={<ProtectedRoute element={<Vets searchTerm={searchTerm} />} />} />
<Route path="/donations" element={<ProtectedRoute element={<Donations searchTerm={searchTerm} />} />} />
<Route path="/dispatchmanagement" element={<ProtectedRoute element={<DispatchManagement searchTerm={searchTerm} />} />} />
<Route path="/dispatchmanagement/list" element={<ProtectedRoute element={<DispatchManagement searchTerm={searchTerm} />} />} />
<Route path="/fundraisingmanagement" element={<ProtectedRoute element={<FundraisingManagement searchTerm={searchTerm} />} />} />
<Route path="/fundraisingmanagement/list" element={<ProtectedRoute element={<FundraisingManagement searchTerm={searchTerm} />} />} />
<Route path="/trainingsupport" element={<ProtectedRoute element={<TrainingSupport searchTerm={searchTerm} />} />} />
<Route path="/trainingsupport/list" element={<ProtectedRoute element={<TrainingSupport searchTerm={searchTerm} />} />} />
<Route path="/trainingsupport/trainergender" element={<ProtectedRoute element={<TrainingSupportByTrainerGender searchTerm={searchTerm} />} />} />
<Route path="/trainingsupport/trainingtype" element={<ProtectedRoute element={<TrainingSupportByTrainingType searchTerm={searchTerm} />} />} />
<Route path="/trainingsupport/sessionstatus" element={<ProtectedRoute element={<TrainingSupportBySessionStatus searchTerm={searchTerm} />} />} />
<Route path="/adoptionfollowup" element={<ProtectedRoute element={<AdoptionFollowUp searchTerm={searchTerm} />} />} />
<Route path="/adoptionfollowup/list" element={<ProtectedRoute element={<AdoptionFollowUp searchTerm={searchTerm} />} />} />
<Route path="/adoptionfollowup/followupstatus" element={<ProtectedRoute element={<AdoptionFollowUpByFollowUpStatus searchTerm={searchTerm} />} />} />
<Route path="/adoptionfollowup/contactmethod" element={<ProtectedRoute element={<AdoptionFollowUpByContactMethod searchTerm={searchTerm} />} />} />
<Route path="/licensingmanagement" element={<ProtectedRoute element={<LicensingManagement searchTerm={searchTerm} />} />} />
<Route path="/licensingmanagement/list" element={<ProtectedRoute element={<LicensingManagement searchTerm={searchTerm} />} />} />
<Route path="/licensingmanagement/status" element={<ProtectedRoute element={<LicensingManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/licensingmanagement/licensetype" element={<ProtectedRoute element={<LicensingManagementByLicenseType searchTerm={searchTerm} />} />} />
<Route path="/lostandfound" element={<ProtectedRoute element={<LostAndFound searchTerm={searchTerm} />} />} />
<Route path="/lostandfound/list" element={<ProtectedRoute element={<LostAndFound searchTerm={searchTerm} />} />} />
<Route path="/lostandfound/status" element={<ProtectedRoute element={<LostAndFoundByStatus searchTerm={searchTerm} />} />} />
<Route path="/lostandfound/reportergender" element={<ProtectedRoute element={<LostAndFoundByReporterGender searchTerm={searchTerm} />} />} />
<Route path="/medicalrecords" element={<ProtectedRoute element={<MedicalRecords searchTerm={searchTerm} />} />} />
<Route path="/medicalrecords/list" element={<ProtectedRoute element={<MedicalRecords searchTerm={searchTerm} />} />} />
<Route path="/behavioraltracking" element={<ProtectedRoute element={<BehavioralTracking searchTerm={searchTerm} />} />} />
<Route path="/behavioraltracking/list" element={<ProtectedRoute element={<BehavioralTracking searchTerm={searchTerm} />} />} />
<Route path="/behavioraltracking/behaviortype" element={<ProtectedRoute element={<BehavioralTrackingByBehaviorType searchTerm={searchTerm} />} />} />
<Route path="/accounts" element={<ProtectedRoute element={<Accounts searchTerm={searchTerm} />} />} />
<Route path="/accounts/list" element={<ProtectedRoute element={<Accounts searchTerm={searchTerm} />} />} />
<Route path="/accounts/accountstatus" element={<ProtectedRoute element={<AccountsByAccountStatus searchTerm={searchTerm} />} />} />
<Route path="/accounts/accounttype" element={<ProtectedRoute element={<AccountsByAccountType searchTerm={searchTerm} />} />} />
<Route path="/inventory" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/list" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/status" element={<ProtectedRoute element={<InventoryByStatus searchTerm={searchTerm} />} />} />
<Route path="/inventory/category" element={<ProtectedRoute element={<InventoryByCategory searchTerm={searchTerm} />} />} />
<Route path="/inventory/itemtype" element={<ProtectedRoute element={<InventoryByItemType searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
